<template>
	<div id="MAM_terminalList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="formInline.merchant_number" placeholder="请输入商户编号"></el-input>
				</el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="formInline.terminal_sn" placeholder="请输入终端SN"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="formInline.agent_no" placeholder="请输入直属代理商编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="formInline.p2_agent_no" placeholder="请输入所属代理商编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select
                        v-model="formInline.brand_id"
                        filterable
                        clearable
                        style="width:100%"
                        placeholder="请选择政策名称"
                    >
                        <el-option
                            v-for="(item,index) in brandList"
                            :label="item.name"
                            :value="item.id"
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item>
					<el-select :editable="false" size="medium" v-model="formInline.status" filterable clearable style="width:100%"
						placeholder="请选择达标状态">
						<el-option label="进行中" value="1"></el-option>
						<el-option label="已达标" value="2"></el-option>
						<el-option label="未达标" value="3"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate2"
                        type="monthrange"
                        range-separator="至"
                        start-placeholder="考核开始日期"
                        end-placeholder="考核结束日期"
                        value-format="yyyy-MM"
                        @change="pickerChange2"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="创建开始日期"
                        end-placeholder="创建结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(formInline)">查询</el-button>
					<el-button size="medium" type="primary" icon="el-icon-download" style="font-size: 12px;" @click="downLoad(formInline)">导出数据</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			
			<el-table  :data="transferList.list" size="mini" border style="width: 100%" v-loading="loading">
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
				<!-- 代理商名称 -->
				<el-table-column header-align="center" align="center" prop="merchant_name" label="商户名称" min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="merchant_number" label="商户编号" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="terminal_sn" label="终端SN" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="transaction_money" label="缴纳服务费金额(元)" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="transaction_time" label="缴纳服务费时间" min-width="160"></el-table-column>
                <el-table-column header-align="center" align="center" prop="brand_name" label="政策名称" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="agent_no" label="直属代理商编号" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="nickname" label="直属代理商昵称" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="p2_agent_no" label="所属代理商编号" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="p2_nickname" label="所属代理商昵称" min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="status_text" label="达标情况" min-width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 1" style="color: #E89E42;">{{scope.row.status_text}}</span>
                        <span v-if="scope.row.status == 2" style="color: #81B437;">{{scope.row.status_text}}</span>
                        <span v-if="scope.row.status == 3" style="color: #C72A29;">{{scope.row.status_text}}</span>
					</template>
				</el-table-column>
                <el-table-column header-align="center" align="center" prop="month_data_num" label="当前达标状态" min-width="120">
                    <template slot-scope="scope">
                        <span @click="detailClick(scope.row)" style="color: #5A9CF8;text-decoration: underline;">{{scope.row.reach_num}}/12</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="start_date" label="考核开始时间" min-width="160">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="end_date" label="考核结束时间" min-width="160">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="create_time" label="创建时间" min-width="160">
                </el-table-column>
				
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize" style="text-align: center"></paginations>
		</el-card>

        <el-dialog title="商户达标情况" width="800px" :visible="isDetail"  @close="handleClose">
            <el-table :data="detailItem" size="mini" border style="width: 100%">
            	<!-- 代理商名称 -->
            	<el-table-column header-align="center" align="center" prop="date" label="日期" min-width="160">
            	</el-table-column>
                <el-table-column header-align="center" align="center" prop="month_transaction_money" label="贷记卡交易额(元)" min-width="160">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="status_text" label="考核状态" min-width="160">
                    <template slot-scope="scope">
                    	<span v-if="scope.row.status == 1" style="color: #E89E42;">{{scope.row.status_text}}</span>
                        <span v-if="scope.row.status == 2" style="color: #81B437;">{{scope.row.status_text}}</span>
                        <span v-if="scope.row.status == 3" style="color: #C72A29;">{{scope.row.status_text}}</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="reach_time" label="达标日期" min-width="160">
                </el-table-column>
            </el-table>
        	
        </el-dialog>
	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "bigDividendFinishList",
		data() {
			return {
				formInline: {
					merchant_number: '', //商户编号
					terminal_sn: '', //终端SN
					brand_id: '', //政策ID
                    agent_no: '', //直属代理编号
                    p2_agent_no: '', //所属代理编号
                    evaluation_start_time: '', //考核开始时间【年月】
                    evaluation_end_time: '', //考核结束时间【年月】
                    start_time: '', //创建开始时间
                    end_time: '', //创建结束时间
                    status:'' // 达标情况//达标状态 1:进行中 2:已达标 3:未达标
				},
				transferList: {
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0 //总数
				},
				loading: true,
                isDetail:false,
                cellItem:{},
                detailItem:{},
                brandList:[],
                currentDate: '',
                rangeDate: [], //时间范围
                currentDate2: '',
                rangeDate2: [], //时间范围
			}
		},
		mounted() {
			this.getData()
			this.$api.post('brand/brand_list', {}, res => { //获取终端类型
			    if (res.code == 0) {
			        this.brandList = res.data.list;
			    } else {
			        this.$$message.success(res.msg);
			    }
			});
		},
		components: {
			paginations,
		},
		methods: {
            pickerChange(DateArr) { //时间选择器
                this.formInline.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.formInline.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
                this.rangeDate = [this.searchForm.start_time, this.searchForm.end_time];
            },
            pickerChange2(DateArr) { //时间选择器
                this.formInline.evaluation_start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.formInline.evaluation_end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
                this.rangeDate = [this.searchForm.evaluation_start_time, this.searchForm.evaluation_end_time];
            },
            handleSelectionChange(rows){
            	this.multipleSelection = rows;
            },
            selectableFun(item){
            	if (item.send_status > 1 && item.status == 20 && item.is_can_reward == 1) {
            		return true
            	}else {
            		return false
            	}
            },

            handleClose() {
                this.cellItem = {}
            	this.isDetail = false;
            },
            detailClick(item){
                this.cellItem = item
                this.isDetail = true
                this.getDetail()
            },
            getDetail() {
            	this.$api.post("merchant_transaction_cash_reward/rewardRecordList", {merchant_transaction_cash_reward_id:this.cellItem.merchant_transaction_cash_reward_id}, res => {
            		let data = res.data;
            		this.detailItem = res.data;
            		//渲染结束后取消加载
            		this.loading = false;
            	})
            },
			onSearch() { //搜索
				this.page.currentPage = 1;
				// 表单提交
				this.getData()
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.getData();
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.getData()
			},
			getData() {
                this.formInline.page = this.page.currentPage
                this.formInline.limit = this.page.pageSize
				this.$api.post("merchant_transaction_cash_reward/rewardList", this.formInline, res => {
					let data = res.data;
					this.page.total = data.count; //总数
					this.transferList.list = res.data.list;
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			downLoad(formInline) { //导出
				let reqData = {
					type: 35,
					value: JSON.stringify(formInline)
				};

				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}

				})
			}
		}
	};
</script>





<style lang="scss" scope>
	.el-input__inner {
		font-size: 12px;
	}

	.el-form-item {
		margin-bottom: 5px;
	}

	.el-date-editor .el-range-input,
	.el-date-editor .el-range-separator {
		font-size: 12px;
	}

	.el-popover__title {
		font-size: 12px;
		font-weight: 700;
	}

	.MAM_terminalList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}

		.tableTitle {
			display: inline-block;
			margin-right: 20px;
		}
	}

	.terminal_operate {
		display: flex;
	}

	.el-button {
		font-size: 12px !important;
	}
</style>